/** pt-BR 国家/地区落地页 */
export default {
  "label": "Brazil",
  "path": "/locations/free-brazil-vpn/",
  "hreflang": "pt-BR",
  "htmlLang": "pt-BR",
  "title": "Secure VPN – VPN grátis com IP brasileiro",
  "description": "Use o Secure VPN para proteger sua conexão e saiba como obter um endereço IP brasileiro. Confira os servidores disponíveis e veja como configurar a conexão VPN.",
  "h1": "VPN grátis com endereço IP brasileiro",
  "heroLead": "Baixe o Secure VPN e tenha uma conexão criptografada rápida para navegar, assistir, jogar e proteger sua privacidade online.",
  "heroPoints": [
    "1 dispositivo protegido",
    "Sem logs nem anúncios",
    "Ilimitado e grátis",
    "Servidores VPN globais"
  ],
  "heroCtaLabel": "Baixar APK",
  "privacyTitle": "Proteja sua privacidade com um VPN grátis",
  "privacyLead": "O Secure VPN é um aplicativo simples que ajuda a manter sua privacidade na internet. Com um toque, conecte-se a um servidor seguro, oculte seu endereço IP e navegue com mais segurança em Wi-Fi público, redes móveis ou internet residencial. É uma boa escolha para quem quer proteção rápida sem configurações complicadas.",
  "privacySubtitle": "Principais benefícios",
  "privacyBenefits": [
    {
      "title": "100% grátis e sem limite",
      "desc": "Tenha acesso VPN ilimitado sem limites diários de dados ou cobranças escondidas."
    },
    {
      "title": "Proteção em Wi-Fi público",
      "desc": "Fique mais seguro em cafés, aeroportos, hotéis e outras redes compartilhadas."
    },
    {
      "title": "Política sem registros",
      "desc": "Sua atividade é sua. Não mantemos registros dos sites que você visita usando a VPN."
    }
  ],
  "featuresTitle": "O que é possível com o VPN grátis Secure",
  "featureCards": [
    {
      "title": "Segurança online criptografada",
      "desc": "Proteja seus dados pessoais e o tráfego da internet com criptografia forte."
    },
    {
      "title": "Servidores globais rápidos",
      "desc": "Conecte-se a servidores VPN velozes para navegar, assistir e usar a internet todos os dias."
    },
    {
      "title": "Várias localizações",
      "desc": "Escolha servidores em diferentes países e mantenha uma conexão estável onde estiver."
    },
    {
      "title": "Conexão com um toque",
      "desc": "Conecte-se na hora ao melhor servidor disponível sem configuração complicada."
    },
    {
      "title": "Servidores no mundo todo",
      "desc": "Acesse servidores globais rápidos e confiáveis sempre que precisar."
    },
    {
      "title": "Streaming sem interrupções",
      "desc": "Assista a vídeos, transmissões e conteúdos online com uma conexão estável."
    },
    {
      "title": "Alto desempenho",
      "desc": "Servidores otimizados oferecem conexão rápida e estável para navegar e jogar."
    },
    {
      "title": "100% grátis e sem limite",
      "desc": "Tenha acesso VPN ilimitado sem limites diários de dados ou cobranças escondidas."
    }
  ],
  "extraTitle": "Mais motivos para usar o Secure VPN",
  "extraItems": [
    "Leve e fácil de usar",
    "Proteção em Wi-Fi público",
    "Oculte seu endereço IP",
    "Navegue sem limites",
    "Servidores rápidos e estáveis"
  ],
  "extraCta": "Baixar APK",
  "extraPlayPrefix": "Download from",
  "dailyTitle": "Como o Secure VPN faz parte do seu dia online",
  "dailyScenes": [
    {
      "title": "Jogue sem limites de rede",
      "tags": [
        "PUBG Mobile",
        "Call of Duty: Mobile",
        "Free Fire",
        "Mobile Legends"
      ]
    },
    {
      "title": "Chamadas e mensagens privadas",
      "tags": [
        "WhatsApp",
        "Telegram",
        "Skype",
        "Viber"
      ]
    },
    {
      "title": "Proteja-se em Wi-Fi público",
      "tags": [
        "Wi-Fi público",
        "Trabalhos",
        "Escolas",
        "Aeroportos"
      ]
    },
    {
      "title": "Proteja sua privacidade online",
      "tags": [
        "Criptografia forte",
        "Ocultar endereço IP",
        "Política sem registros",
        "Privacidade contra a operadora"
      ]
    }
  ],
  "installTitle": "Como baixar e instalar o Secure VPN",
  "installLead": "Siga estes passos simples:",
  "installSteps": [
    {
      "title": "Acesse a página de download",
      "desc": "Vá à página de download do Secure VPN ou a uma loja de aplicativos confiável para obter a versão mais recente."
    },
    {
      "title": "Baixe o Secure VPN",
      "desc": "Toque em Baixar e aguarde o término do download do APK ou do aplicativo."
    },
    {
      "title": "Ative a permissão de instalação",
      "desc": "Para instalar o APK, permita Instalar aplicativos desconhecidos no navegador ou gerenciador de arquivos."
    },
    {
      "title": "Instale o aplicativo",
      "desc": "Abra o arquivo baixado, toque em Instalar e aguarde a conclusão."
    },
    {
      "title": "Abra e conecte",
      "desc": "Inicie o Secure VPN, escolha um servidor e toque em Conectar para iniciar uma conexão segura."
    },
    {
      "title": "Navegue com segurança",
      "desc": "Seu tráfego agora está protegido. Navegue, assista, jogue e use Wi-Fi público com mais segurança."
    }
  ],
  "installCta": "Baixar APK",
  "compareTitle": "Aplicativo Secure VPN x proxy web grátis",
  "compareLead": "Um aplicativo VPN e um proxy web grátis ajudam a aumentar a privacidade, mas funcionam de maneiras diferentes. O VPN protege todo o dispositivo com conexão criptografada, enquanto o proxy é voltado ao navegador.",
  "compareNote": "Para atividades regulares na internet, o aplicativo Secure VPN oferece uma solução mais completa e confiável.",
  "compareHeaders": [
    "Recurso",
    "Aplicativo Secure VPN",
    "Proxy web grátis"
  ],
  "compareRows": [
    {
      "feature": "Instalação",
      "vpn": "Instalação fácil do app",
      "proxy": "Não exige instalação"
    },
    {
      "feature": "Uso",
      "vpn": "Protege todos os apps e sites",
      "proxy": "Funciona apenas no navegador"
    },
    {
      "feature": "Privacidade",
      "vpn": "Criptografia forte e conexão segura",
      "proxy": "Privacidade básica de navegação"
    },
    {
      "feature": "Velocidade",
      "vpn": "Servidores VPN otimizados",
      "proxy": "Depende do servidor proxy"
    },
    {
      "feature": "Proteção do dispositivo",
      "vpn": "Proteção completa",
      "proxy": "Somente no navegador"
    }
  ],
  "privacyChoiceTitle": "Qual escolher?",
  "privacyChoiceP1": "se você quer mais privacidade, conexão rápida e proteção de todo o dispositivo.se você quer mais privacidade, conexão rápida e proteção de todo o dispositivo.",
  "privacyChoiceP2": "se precisa apenas de acesso temporário pelo navegador para tarefas simples.",
  "privacyChoiceP3": "Para atividades regulares na internet, o aplicativo Secure VPN oferece uma solução mais completa e confiável.",
  "reviewsTitle": "Aprovado pelos usuários",
  "reviewsLead": "Usuários do mundo todo confiam no Secure VPN por suas conexões rápidas, estáveis e seguras. Servidores confiáveis e proteção de privacidade ajudam a navegar, assistir, jogar e se conectar com segurança todos os dias.",
  "reviews": [
    {
      "name": "James",
      "text": "Conexão rápida e fácil de usar. Consigo navegar com segurança onde estiver."
    },
    {
      "name": "Emily",
      "text": "O Secure VPN funciona bem e mantém minha conexão estável em Wi-Fi público."
    },
    {
      "name": "Daniel",
      "text": "Ótima velocidade e servidores confiáveis para streaming, jogos e uso diário."
    }
  ],
  "faqTitle": "Perguntas frequentes",
  "faqs": [
    {
      "q": "Uma VPN deixa a internet mais lenta?",
      "a": "A velocidade pode cair um pouco porque o tráfego passa por um servidor seguro. Na maioria dos casos, a diferença é pequena e você continua navegando e assistindo normalmente."
    },
    {
      "q": "O SecureVPN é seguro?",
      "a": "O SecureVPN criptografa sua conexão e oculta seu endereço IP. Baixe sempre de fontes confiáveis e leia a política de privacidade."
    },
    {
      "q": "Usar VPN é legal?",
      "a": "Na maioria dos países, usar VPN é legal e comum para privacidade e segurança. Siga as leis e regras aplicáveis na sua região."
    },
    {
      "q": "Por quanto tempo posso ficar conectado?",
      "a": "Você pode manter o SecureVPN conectado enquanto precisar de uma conexão protegida. Limites podem variar conforme a versão e as condições do serviço."
    },
    {
      "q": "Como usar o Secure VPN?",
      "a": "Instale o Secure VPN, abra o aplicativo, escolha um servidor e toque em conectar. Depois de conectado, seu tráfego passa pela VPN."
    },
    {
      "q": "A VPN afeta a bateria?",
      "a": "A VPN pode consumir um pouco mais de bateria por manter a conexão ativa, mas o impacto costuma ser mínimo no uso diário."
    }
  ]
};
